import { Content } from '@backstage/core-components';
import { DashboardExecutive } from '../dashboard';
import '../dashboard/dashboard.css';

export const HomePage = () => (
  <Content className="arx-dashboard-content">
    <DashboardExecutive />
  </Content>
);
